export default __webpack_public_path__ + "static/BBclip-f9f0f8cc3130da41a32f86648f8d49c5.mp4";